export class DocumentTypeAuthorizedModel {
    Invoice: boolean;
    OutgoingInvoice: boolean;
    IncomingInvoice: boolean;
    EarchiveInvoice: boolean;
    MyCustomIncomingInvoice: boolean;

    DespatchAdvice: boolean;
    OutgoingDespatchAdvice: boolean;
    IncomingDespatchAdvice: boolean;
    MyCustomIncomingDespatchAdvice: boolean;

    Receipt: boolean;
    CreditNote: boolean;
    ESMM: boolean;
    BILL: boolean;

    Migration: boolean;
    MigratedOutgoingInvoice: boolean;
    MigratedIncomingInvoice: boolean;

    constructor() {
        this.Invoice = false;
        this.OutgoingInvoice = false;
        this.IncomingInvoice = false;
        this.EarchiveInvoice = false;
        this.MyCustomIncomingInvoice = false;

        this.DespatchAdvice = false;
        this.OutgoingDespatchAdvice = false;
        this.IncomingDespatchAdvice = false;
        this.MyCustomIncomingDespatchAdvice = false;

        this.Receipt = false;
        this.CreditNote = false;
        this.ESMM = false;
        this.BILL = false;

        this.Migration = false;
        this.MigratedOutgoingInvoice = false;
        this.MigratedIncomingInvoice = false;
    }
}